var map = {
	"./image-16-copyright-min-800x508.jpg": 574,
	"./image-40-copyright-min-90x90.jpg": 2207,
	"./image-45-copyright-min-800x508.jpg": 2174,
	"./istockphoto-1341819113-612x612.jpg": 4825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;